import { indexTopics } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            专题索引
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            热门专题合集
          </h2>
          <p className="text-foreground-500 mt-3 text-sm md:text-base max-w-2xl mx-auto">
            按题材分类浏览，快速找到你感兴趣的剧集专题，吃瓜视频为你精心整理
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {indexTopics.map((topic) => (
            <a
              key={topic.title}
              href={topic.href}
              className="group cursor-pointer bg-background-50 border border-background-200 rounded-xl p-5 md:p-6 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-200 flex items-start gap-4"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-500 transition-colors duration-200">
                <i className={`${topic.icon} text-lg text-primary-600 group-hover:text-white transition-colors duration-200`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 truncate">
                  {topic.title}
                </h3>
                <p className="text-sm text-foreground-500 mt-1.5 line-clamp-2 leading-relaxed">
                  {topic.description}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}